import {
    FontResourceItem,
    Inject,
    ISimpleControllerConfiguration,
    GameRandom, ResourceItem, ResourceItemType,
    SimpleBaseController, SoundType
} from "../modules/@denishussar/html5-game-engine";
import { GameModalsEnum, GameModel } from "./Models/GameModel";
import { GameLogic } from "./Logic/GameLogic";
import { AnimationContents } from "./Controllers/AnimationContents";
import { GameController } from "./Controllers/Game/GameController";
import { getCookie } from "./Utils/Helpers";
import { PauseScreenController } from "./Controllers/Modals/Pause/PauseScreenController";
import { SoundConstants, SoundLevels } from "./Constants/SoundConstants";
import { PreloaderGameController } from "./Controllers/Preloader/PreloaderGameController";
import { PopupBackgroundController } from "./Controllers/Common/PopupBackgroundController";
import { SystemScreenController } from "./Controllers/Modals/System/SystemScreenController";
import { LeaderBoardScreenController } from "./Controllers/Modals/LeaderBoard/LeaderBoardScreenController";
import { TapToPlayScreenController } from "./Controllers/Modals/TapToPlay/TapToPlayScreenController";
import { EnterNameScreenController } from "./Controllers/Modals/EnterName/EnterNameScreenController";
import { ChooseSkinScreenController } from "./Controllers/Modals/ChooseSkin/ChooseSkinScreenController";
import { TutorialScreenController } from "./Controllers/Modals/Tutorial/TutorialScreenController";

export interface IRootControllerOptions {
    version: string
}

export class RootController extends SimpleBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IRootControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("RootController");
    }

    protected getConfiguration(): ISimpleControllerConfiguration {

        return {
            childControllers: {

            },
            resources: {
                font0: new FontResourceItem("TradeGothicLT"),
                font1: new FontResourceItem("TradeGothicLT-Bold"),
                mainScreenArt: new ResourceItem("MAIN_SCREEN_JSON", AnimationContents.MAIN_SCREEN_JSON, ResourceItemType.pixiAnimation),
                errorScreenArt: new ResourceItem("Error_SCREEN_JSON", AnimationContents.ERROR_MODAL_JSON, ResourceItemType.pixiAnimation)
            },
            modelWatch: {
                "showMainMenuContainer": async (showMainMenuContainer: boolean) => {
                    console.log('Root:showMainMenuContainer', showMainMenuContainer);

                    if (!showMainMenuContainer) {
                        await this.removeChildControllerByNameAsync("main_menu");
                    } else {
                        if (this.$childControllers['main_menu']) {
                            await this.removeChildControllerByNameAsync("main_menu");
                        }
                        if (this.$childControllers['GameScreen']) {
                            this.removeChildControllerByName("GameScreen");
                        }

                    }
                },
                "startNewGame": async (startNewGame: boolean) => {
                    if (startNewGame && !this.$childControllers['GameScreen']) {
                        this.addChildController({
                            controller: GameController,
                            model: this.$model
                        }, "GameScreen");
                        this.addChildController({
                            controller: PopupBackgroundController,
                            model: this.$model
                        }, "PopupBackgroundController");
                    }
                    if (startNewGame) {
                        this._playMusic();
                    }
                },
                "exitGame": async (exitGame: boolean) => {
                    await this.removeChildControllerByNameAsync("GameScreen");
                    await this.removeChildControllerByNameAsync("PopupBackgroundController");
                    this._playMusic();
                },
                "modalState": async (modalState: GameModalsEnum) => {
                    const modal = this.$childControllers.get("modal");
                    console.log('Root:modalState', modalState);
                    if (modal) {
                        await this.removeChildControllerByNameAsync("modal");
                    }

                    if (modalState === GameModalsEnum.pause) {
                        this.addChildController({
                            animationContent: AnimationContents.PAUSE_SCREEN_JSON,
                            libraryName: "pause",
                            controller: PauseScreenController,
                            model: this.$model
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.enterName) {
                        this.addChildController({
                            model: this.$model,
                            controller: EnterNameScreenController
                        }, 'modal');
                    }
                    if (modalState === GameModalsEnum.choosePerson) {
                        this.addChildController({
                            model: this.$model,
                            controller: ChooseSkinScreenController
                        }, 'modal');
                    }
                    if (modalState === GameModalsEnum.tutorial) {
                        this.addChildController({
                            model: this.$model,
                            controller: TutorialScreenController
                        }, 'modal');
                    }
                    if (modalState === GameModalsEnum.tapToStart) {
                        this.addChildController({
                            model: this.$model,
                            controller: TapToPlayScreenController
                        }, 'modal');
                    }
                    if (modalState === GameModalsEnum.error) {
                        this.addChildController({
                            animationContent: AnimationContents.ERROR_MODAL_JSON,
                            libraryName: 'modal',
                            model: this.$model,
                            controller: SystemScreenController,
                            options: {
                                type: 'error',
                            }
                        }, 'modal');
                    }
                    if (modalState === GameModalsEnum.loader) {
                        this.addChildController({
                            animationContent: AnimationContents.ERROR_MODAL_JSON,
                            libraryName: 'modal',
                            model: this.$model,
                            controller: SystemScreenController,
                            options: {
                                type: 'loading'
                            }
                        }, 'modal');
                    }
                    if (modalState === GameModalsEnum.leader_board) {
                        this.addChildController({
                            animationContent: AnimationContents.LEADER_BOARD_MODAL_JSON,
                            libraryName: 'leaderboard',
                            model: this.$model,
                            controller: LeaderBoardScreenController
                        }, 'modal');
                    }
                },
                isSoundsOn: (isOn: boolean) => {
                    this.soundManager.muteSoundsByType(!isOn, SoundType.SFX);
                },
                isMusicOn: (isOn: boolean) => {
                    this.soundManager.setMasterVolume(isOn ? 1 : 0); // TODO: исправить на выключение музыки
                    this._playMusic();
                }
            },
            sounds: [
                {
                    id: SoundConstants.GAME_MUSIC,
                    type: SoundType.Music
                },
                {
                    id: SoundConstants.MENU_MUSIC,
                    type: SoundType.Music
                },
                {
                    id: SoundConstants.GAME_MUSIC_FON,
                    type: SoundType.Music
                }
            ]
        };
    }

    protected async onInitialize() {
        console.log("COOKIE: ", getCookie());

        await this._gameLogic.initStorage();
        await this._gameLogic.initDB();
        await this._gameLogic.loadDB();


        const preloader = this.addChildController({
            controller: PreloaderGameController,
            model: this.$model,
        }, "PreloaderGameController") as PreloaderGameController;

        preloader.onLoadingProgress(0.99);
        this.removeChildControllerByName('PreloaderGameController');

        this.soundManager.muteSoundsByType(!this.$model.isSoundsOn, SoundType.ALL);

        this._gameLogic.hideMainMenuContainer();

        this._gameLogic.showEnterName();
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }
    private _playMusic() {
        if (!this.soundManager.isSoundPlaying(SoundConstants.GAME_MUSIC)) {
            this.soundManager.play(SoundConstants.GAME_MUSIC, true, SoundLevels.levelMusic);
            this.soundManager.play(SoundConstants.GAME_MUSIC_FON, true, SoundLevels.levelAmbient);
        }
    }

    protected onFocus(isFocus: boolean) {
        if (this.$model.startNewGame && !this.$model.pause && !isFocus) {
            this._gameLogic.pause();
            this._gameLogic.showPause();
        }
    }
}
